import { isCourseService } from '../service/service';
const isDateInCurrentYear = date => {
  const now = new Date();
  return now.getFullYear() === date.getFullYear();
};
const isDateInThePast = date => {
  const now = new Date();
  return date.getTime() < now.getTime();
};
const getCourseDuration = _ref => {
  var _service$schedule, _service$schedule2, _service$schedule3;
  let {
    durationFormatter,
    durationsMapperKeys,
    service,
    viewTimezone,
    dateRegionalSettingsLocale
  } = _ref;
  const isPassedEndDate = !(service != null && (_service$schedule = service.schedule) != null && _service$schedule.lastSessionEnd) || (service == null || (_service$schedule2 = service.schedule) == null ? void 0 : _service$schedule2.lastSessionEnd) < new Date();
  if (isPassedEndDate) {
    return durationFormatter(durationsMapperKeys.courseEndedText);
  }
  const startDateAsUTC = service == null || (_service$schedule3 = service.schedule) == null || (_service$schedule3 = _service$schedule3.firstSessionStart) == null ? void 0 : _service$schedule3.toUTCString();
  if (startDateAsUTC) {
    const startDate = new Date(startDateAsUTC);
    const dateFormat = isDateInCurrentYear(startDate) ? {
      month: 'short',
      day: 'numeric',
      timeZone: viewTimezone
    } : {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: viewTimezone
    };
    const formattedDate = new Intl.DateTimeFormat(dateRegionalSettingsLocale, dateFormat).format(startDate);
    return isDateInThePast(startDate) ? durationFormatter(durationsMapperKeys.coursePassedText, {
      date: formattedDate,
      interpolation: {
        escapeValue: false
      }
    }) : durationFormatter(durationsMapperKeys.courseInFutureText, {
      date: formattedDate,
      interpolation: {
        escapeValue: false
      }
    });
  }
  return '';
};
export const getDurationText = _ref2 => {
  var _service$schedule4;
  let {
    dateRegionalSettingsLocale,
    service,
    durationsMapperKeys,
    durationFormatter,
    viewTimezone,
    durationAria = false
  } = _ref2;
  const sessionsDuration = service == null || (_service$schedule4 = service.schedule) == null || (_service$schedule4 = _service$schedule4.availabilityConstraints) == null ? void 0 : _service$schedule4.sessionDurations;
  const firstSessionDuration = sessionsDuration == null ? void 0 : sessionsDuration[0];
  const isDurationVaries = (sessionsDuration == null ? void 0 : sessionsDuration.some(duration => duration !== firstSessionDuration)) || false;
  if (isCourseService(service)) {
    return getCourseDuration({
      dateRegionalSettingsLocale,
      service,
      viewTimezone,
      durationsMapperKeys,
      durationFormatter
    });
  }
  if (isDurationVaries) {
    return durationFormatter(durationsMapperKeys.durationVaries);
  }
  if (firstSessionDuration) {
    return formatDurationFromMinutes({
      durationInMinutes: firstSessionDuration || 0,
      hourUnit: durationsMapperKeys.hourUnit,
      minuteUnit: durationsMapperKeys.minuteUnit,
      durationFormatter,
      durationAria
    });
  }
  return '';
};
const formatDurationFromMinutes = _ref3 => {
  let {
    durationInMinutes,
    hourUnit,
    minuteUnit,
    durationFormatter,
    durationAria = false
  } = _ref3;
  const hours = Math.floor(durationInMinutes / 60);
  const minutes = durationInMinutes % 60;
  let hourText = durationFormatter(hourUnit, {
    hours
  });
  if (durationAria) {
    hourText = hours === 1 ? hourText.slice(0, -1) : hourText;
  }
  const minuteText = durationFormatter(minuteUnit, {
    minutes
  });
  return hours ? hourText + (minutes ? ` ${minuteText}` : '') : minuteText;
};
//# sourceMappingURL=duration.js.map